import * as React from 'react';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import FolderIcon from '@mui/icons-material/Folder';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GroupIcon from '@mui/icons-material/Group';
import DomainIcon from '@mui/icons-material/Domain';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { red } from '@mui/material/colors';
import Grid from '@material-ui/core/Grid';
import MessageIcon from '@mui/icons-material/Message';

const color = red[500];

export default function Navbar() {
  const [value, setValue] = React.useState('index');
  const navigate = useNavigate()
  const handleChange = (event, newValue) => {
    navigate(newValue);
    setValue(newValue);
  };


  const [valueTab, setValueTab] = React.useState('home');
  const location = useLocation()
  const handleChangeTab = (event, newValue) => {
    console.log(newValue)
    if (newValue == 'home') {
      setValueTab("home");
      navigate("/");
      setValue("/");
    }
    else {
      setValueTab(newValue);
      navigate(newValue);
      setValue(newValue);
    }
  };

  React.useEffect(() => {
    console.log(location.pathname)
    if (location.pathname != '/'
      && location.pathname != '/broker'
      && location.pathname != '/client'
      && location.pathname != '/object'
    ) {
      setValueTab('object2')
    }
    else if(location.pathname == '/'){
      setValueTab('home')
    }
    else{
      setValueTab(location.pathname.slice(1))
    }
  }, [])



  return (
    <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
      <Grid container alignItems="center" style={{ justifyContent: "center" }}>
        <Tabs value={valueTab} onChange={handleChangeTab}  TabIndicatorProps={{ sx: { backgroundColor: "#232323", height: "3px" } }}
          sx={{
            // задаем цвет со старта
            "& button": { color: "#232323" },
            "& button.Mui-selected": { color: "#000000" },
            // Задаем цвет активной вкладке
            "& button:focus": { color: "#000000" },
           "&.MuiTabs-scrollButtons.Mui-disabled" :{
              opacity: 0.3
            }
          }}  
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="scrollable force tabs example">
          <Tab icon={<AddToHomeScreenIcon />} sx={{ pl: 1, pr: 2, fontSize: "7px" }} label="Главная" value="home" />
          <Tab icon={<MessageIcon />} sx={{ pl: 2, pr: 2, fontSize: "7px" }} label="Брокер тур" value="broker" />
          <Tab icon={<GroupIcon />} sx={{ pl: 2, pr: 2, fontSize: "7px" }} label="Проверить" value="client" />
          <Tab icon={<DomainIcon />} sx={{ pl: 2, pr: 1, fontSize: "7px", width: "50px" }} label="Жилая недвижимость" value="object" />
          <Tab icon={<HolidayVillageIcon />} sx={{ pl: 2, pr: 1, fontSize: "7px", width: "50px" }} label="Загородная недвижимость" value="object2" />
        </Tabs>
      </Grid>
    </Box>


  );
}